module.exports = __webpack_public_path__ + "img/Butterfly_00212.266c06ff.png";